import 'core-js';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

// Components
import App from './App';
import { FormStateProvider } from './context/form-context/provider';
import { formReducer, initialFormState } from './context/form-context/reducer';

const anchor = document.getElementById('js-membership-application');

const umbracoPageId = anchor?.dataset?.umbracoId
  ? parseInt(anchor?.dataset?.umbracoId)
  : undefined;

const locale = anchor?.dataset.locale;
const debug = anchor?.dataset?.debug?.toLocaleLowerCase() === 'true' || false;
const disabledEId =
  anchor?.dataset?.disableEid?.toLocaleLowerCase() === 'true' || false;
const enableMemberCodeField =
  anchor?.dataset?.enableMemberCodeField?.toLocaleLowerCase() === 'true' ||
  false;
const antiForgeryToken = anchor?.dataset?.antiForgeryToken;

console.log({umbracoPageId})

// Key used for session storage of form state
const storageKey = !disabledEId
  ? 'MemberApplicationState'
  : 'MemberApplicationStateNoEId';

if (anchor) {
  ReactDOM.render(
    <FormStateProvider
      reducer={formReducer}
      initialState={initialFormState}
      storageKey={storageKey}
    >
      <App
        umbracoPageId={umbracoPageId}
        language={locale}
        debug={debug}
        disabledEId={disabledEId}
        enableMemberCodeField={enableMemberCodeField}
        storageKey={storageKey}
        antiForgeryToken={antiForgeryToken}
      />
    </FormStateProvider>,
    anchor
  );
}
